(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-your-part"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      var grid = root.querySelector('.find-part__grid');
      if (!grid) return;

      var groups = {};
      root.querySelectorAll('[data-filter][role="group"]').forEach(function (g) {
        groups[g.dataset.filter] = g;
      });
      var search = root.querySelector('input[data-filter="q"]');
      var toggle = root.querySelector('input[data-filter="interactive"]');
      var count = root.querySelector('[data-count]');
      var reset = root.querySelector('[data-reset]');
      var empty = root.querySelector('[data-empty]');
      var loading = root.querySelector('[data-loading]');
      var state = { vendor: '', system: '', q: '', interactive: false };
      var initial = new URLSearchParams(location.search);

      function items() {
        return Array.prototype.slice.call(grid.children);
      }

      function itemSystems(li) {
        return li.dataset.systems.split('||').filter(Boolean);
      }

      function setGroup(name, value) {
        state[name] = value;
        if (!groups[name]) return;
        groups[name].querySelectorAll('button').forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.value === value ? 'true' : 'false');
        });
      }

      function buildChips(name, values, allLabel) {
        var group = groups[name];
        var wrap = root.querySelector('[data-group="' + name + '"]');
        values = values.slice().sort(function (a, b) {
          return a.localeCompare(b, undefined, { sensitivity: 'base' });
        });
        group.innerHTML = '';
        function add(value, label) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'find-part__chip';
          b.dataset.value = value;
          b.textContent = label;
          b.setAttribute('aria-pressed', state[name] === value ? 'true' : 'false');
          group.appendChild(b);
        }
        add('', allLabel);
        values.forEach(function (v) { add(v, v); });
        wrap.hidden = values.length === 0;
      }

      function refreshChips() {
        var vendors = {};
        var systems = {};
        items().forEach(function (li) {
          if (li.dataset.vendor) vendors[li.dataset.vendor] = true;
          itemSystems(li).forEach(function (s) { systems[s] = true; });
        });
        buildChips('vendor', Object.keys(vendors), 'All brands');
        buildChips('system', Object.keys(systems), 'All systems');
      }

      // Interactive diagrams first; otherwise keep collection order.
      function sortItems() {
        var list = items();
        var ordered = list
          .map(function (li, i) { return { li: li, i: i }; })
          .sort(function (a, b) {
            var ai = a.li.dataset.interactive === 'true' ? 0 : 1;
            var bi = b.li.dataset.interactive === 'true' ? 0 : 1;
            return ai - bi || a.i - b.i;
          });
        ordered.forEach(function (o) { grid.appendChild(o.li); });
      }

      function apply() {
        var q = state.q.trim().toLowerCase();
        var shown = 0;
        items().forEach(function (li) {
          var ok =
            (!state.vendor || li.dataset.vendor === state.vendor) &&
            (!state.system || itemSystems(li).indexOf(state.system) !== -1) &&
            (!state.interactive || li.dataset.interactive === 'true') &&
            (!q || li.dataset.search.indexOf(q) !== -1);
          li.hidden = !ok;
          if (ok) shown++;
        });
        count.textContent = shown + (shown === 1 ? ' diagram' : ' diagrams');
        empty.hidden = shown !== 0 || items().length === 0;
        reset.hidden = !(state.vendor || state.system || q || state.interactive);

        try {
          var params = new URLSearchParams(location.search);
          ['vendor', 'system', 'q', 'interactive'].forEach(function (k) { params.delete(k); });
          if (state.vendor) params.set('vendor', state.vendor);
          if (state.system) params.set('system', state.system);
          if (q) params.set('q', state.q.trim());
          if (state.interactive) params.set('interactive', '1');
          var qs = params.toString();
          history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
        } catch (e) {}
      }

      function refreshAll() {
        sortItems();
        refreshChips();
        apply();
      }

      Object.keys(groups).forEach(function (name) {
        groups[name].addEventListener('click', function (e) {
          var btn = e.target.closest('button');
          if (!btn) return;
          setGroup(name, btn.dataset.value);
          apply();
        });
      });

      search.addEventListener('input', function () {
        state.q = search.value;
        apply();
      });

      toggle.addEventListener('change', function () {
        state.interactive = toggle.checked;
        apply();
      });

      reset.addEventListener('click', function () {
        setGroup('vendor', '');
        setGroup('system', '');
        state.q = '';
        search.value = '';
        state.interactive = false;
        toggle.checked = false;
        apply();
      });

      state.vendor = initial.get('vendor') || '';
      state.system = initial.get('system') || '';
      state.q = initial.get('q') || '';
      state.interactive = initial.get('interactive') === '1';
      search.value = state.q;
      toggle.checked = state.interactive;
      refreshAll();

      // The collection is paginated 50 at a time; pull in the remaining pages
      // so brand/system filters and search cover every diagram.
      function loadRest() {
        var next = root.querySelector('[data-next-page]');
        if (!next) return;
        var href = next.getAttribute('href');
        next.remove();
        loading.hidden = false;
        fetch(href)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextRoot = doc.querySelector('[data-find-part]');
            if (!nextRoot) return;
            nextRoot.querySelectorAll('.find-part__grid > li').forEach(function (li) {
              grid.appendChild(document.importNode(li, true));
            });
            var more = nextRoot.querySelector('[data-next-page]');
            if (more) grid.parentNode.insertBefore(document.importNode(more, true), grid.nextSibling);
            refreshAll();
            loadRest();
          })
          .catch(function () {})
          .then(function () {
            if (!root.querySelector('[data-next-page]')) loading.hidden = true;
          });
      }
      loadRest();
    }

    function boot() {
      document.querySelectorAll('[data-find-part]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resources-library"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var HAND =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"/><path d="M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"/><path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5"/><path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"/><path d="M5 3l-1 -1"/><path d="M4 7h-1"/><path d="M14 3l1 -1"/><path d="M15 6h1"/></svg>';

    function list(str) {
      return (str || '').split(/\s*,\s*|\|\|/).map(function (s) { return s.trim(); }).filter(Boolean);
    }

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function plural(t) {
      return /s$/i.test(t) ? t : t + 's';
    }

    function ext(name) {
      var m = /\.([a-z0-9]{2,5})$/i.exec(name || '');
      return m ? m[1].toUpperCase() : '';
    }

    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      var app = root.querySelector('[data-app]');
      var source = root.querySelector('[data-source]');
      var results = root.querySelector('[data-results]');
      var count = root.querySelector('[data-count]');
      var clear = root.querySelector('[data-clear]');
      var empty = root.querySelector('[data-empty]');
      var none = root.querySelector('[data-none]');
      var qInput = root.querySelector('[data-q]');
      var bars = {};
      root.querySelectorAll('[data-filter]').forEach(function (el) { bars[el.dataset.filter] = el; });

      var typeOrder = list(app.dataset.types);
      var compOrder = list(app.dataset.components);
      var groupedType = app.dataset.groupedType;
      var collapse = (app.dataset.collapse || '').split(',').map(Number);
      var showFirst = collapse[0] || 0;
      var collapseOver = collapse[1] || 0;
      var showMin = collapse[2] || 0;
      var expanded = {};
      var generalGroups = list(app.dataset.generalGroups);
      var otherLabel = app.dataset.otherLabel || 'Other';
      var logos = {};
      var tpl = root.querySelector('[data-brand-logos]');
      if (tpl) {
        tpl.content.querySelectorAll('[data-brand]').forEach(function (s) {
          if (s.dataset.brand) logos[s.dataset.brand] = s.dataset.logo || '';
        });
      }

      var docs = [];
      var params = new URLSearchParams(location.search);
      var state = {
        q: params.get('q') || '',
        type: params.get('type') || '',
        component: params.get('component') || '',
        brand: params.get('brand') || ''
      };

      function readSource(ul) {
        ul.querySelectorAll(':scope > li[data-title]').forEach(function (li) {
          var files = [];
          var link = '';
          li.querySelectorAll('a').forEach(function (a) {
            if (a.hasAttribute('data-file')) files.push({ url: a.getAttribute('href'), name: a.dataset.file, alt: a.dataset.alt || '' });
            else if (a.hasAttribute('data-link')) link = a.getAttribute('href');
          });
          docs.push({
            title: li.dataset.title,
            fullTitle: li.dataset.fullTitle || '',
            hasLabel: !!li.dataset.fullTitle && li.dataset.fullTitle !== li.dataset.title,
            brand: li.dataset.brand || 'Other',
            type: li.dataset.type || '',
            components: list(li.dataset.components),
            system: (li.dataset.system || '').trim(),
            featured: li.dataset.featured === 'true',
            files: files,
            link: link
          });
        });
      }

      function ordered(values, order) {
        var seen = {};
        values.forEach(function (v) { seen[v] = true; });
        var out = order.filter(function (v) { return seen[v]; });
        Object.keys(seen).sort().forEach(function (v) {
          if (out.indexOf(v) === -1) out.push(v);
        });
        return out;
      }

      function matches(d, ignore) {
        var q = state.q.trim().toLowerCase();
        if (q) {
          var hay = [d.title, d.fullTitle, d.brand, d.system, d.type, d.components.join(' ')]
            .concat(d.files.map(function (f) { return f.name + ' ' + f.alt; }))
            .join(' ')
            .toLowerCase();
          var words = q.split(/\s+/);
          for (var i = 0; i < words.length; i++) if (hay.indexOf(words[i]) === -1) return false;
        }
        if (ignore !== 'type' && state.type) {
          if (state.type === 'interactive' ? !isInteractive(d) : d.type !== state.type) return false;
        }
        if (ignore !== 'component' && state.component && d.components.indexOf(state.component) === -1) return false;
        if (ignore !== 'brand' && state.brand && d.brand !== state.brand) return false;
        return true;
      }

      function highlight(text) {
        var out = esc(text);
        state.q.trim().split(/\s+/).filter(Boolean).forEach(function (w) {
          var re = new RegExp('(' + esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
          out = out.replace(re, '<mark>$1</mark>');
        });
        return out;
      }

      function linkFor(href, inner) {
        return '<a href="' + esc(href) + '" target="_blank" rel="noopener">' + inner +
          '<span class="visually-hidden"> (opens in a new tab)</span></a>';
      }

      function isInteractive(d) {
        return !d.files.length && /\/products\//.test(d.link) && !/\.pdf(\?|#|$)/i.test(d.link);
      }

      // Display options (theme editor): type icons, shorter names under their
      // system heading, and hiding the "PDF" marker. Each can be switched off.
      var TOOL =
        '<svg class="res__ico res__ico--install" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"/></svg>';
      var SCHEMA =
        '<svg class="res__ico res__ico--diagram" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"/><path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"/></svg>';
      var opts = (app.dataset.display || '').split(',');
      var showIcons = opts.indexOf('icons') !== -1;
      var shorten = opts.indexOf('shorten') !== -1;
      var hidePdf = opts.indexOf('hidepdf') !== -1;
      var dropWords = list(app.dataset.dropWords);

      function fmtTag(name) {
        var e = ext(name);
        return e && !(hidePdf && e === 'PDF') ? '<span class="res__fmt">' + e + '</span>' : '';
      }

      // "Donovan Bullet Parts Diagram" under Bullet -> "Parts Diagram".
      // Removes the brand, the system name and any extra words (e.g. Shurco)
      // as whole words; keeps the original if nothing sensible is left.
      function shortName(text, d) {
        if (!shorten || !text) return text;
        var out = text;
        [d.brand, d.brand.replace(/\s+/g, ''), d.system].concat(dropWords).forEach(function (w) {
          if (!w) return;
          var word = w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          var re = new RegExp('(^|[\\s\\-–:/])' + word + '(?=$|[\\s\\-–:/])', 'ig');
          out = out.replace(re, '$1');
        });
        out = out.replace(/\s{2,}/g, ' ').replace(/^[\s\-–:/,]+|[\s\-–:/,]+$/g, '').trim();
        return out.length >= 3 ? out : text;
      }

      function typeIcon(d) {
        if (!showIcons) return '';
        return /diagram/i.test(d.type) ? SCHEMA : TOOL;
      }

      function itemHtml(d) {
        var title = highlight(d.hasLabel ? d.title : shortName(d.title, d));
        var icon = typeIcon(d);
        if (d.files.length === 1) {
          var f = d.files[0];
          return '<li class="res__item">' + linkFor(f.url, icon + title) + fmtTag(f.name) + '</li>';
        }
        if (d.files.length > 1) {
          // Each file shows its Alt text (Content > Files) if set, else its
          // cleaned-up name; files are listed A-Z by that label.
          var fileRows = d.files.map(function (f) {
            return { f: f, label: f.alt || shortName(f.name.replace(/\.[a-z0-9]{2,5}$/i, '').replace(/[-_]+/g, ' '), d) };
          }).sort(function (x, y) {
            return x.label.localeCompare(y.label, undefined, { numeric: true, sensitivity: 'base' });
          });
          return '<li class="res__item"><span class="res__group-label">' + icon + title + '</span><ul class="res__files" role="list">' +
            fileRows.map(function (r) {
              return '<li>' + linkFor(r.f.url, esc(r.label)) + fmtTag(r.f.name) + '</li>';
            }).join('') + '</ul></li>';
        }
        if (d.link) {
          var isProduct = isInteractive(d);
          var isPdf = /\.pdf(\?|#|$)/i.test(d.link);
          var tag = isProduct
            ? '<span class="res__interactive">' + HAND + 'Interactive</span>'
            : (isPdf && !hidePdf ? '<span class="res__fmt">PDF</span>' : '');
          return '<li class="res__item">' + linkFor(d.link, icon + title) + tag + '</li>';
        }
        return '<li class="res__item">' + icon + title + '</li>';
      }

      // Brand > tarp system > documents. Real systems A-Z, then the general
      // groups (in the configured order), then documents with no system.
      // On the full overview (no search or filters), a brand with many
      // systems shows the first few and a "Show all" toggle.
      // Within a system: types in the configured order (Parts Diagrams
      // first), then A-Z. Types not in the setting go last.
      function byType(list) {
        var rank = function (t) {
          var i = typeOrder.indexOf(t);
          return i === -1 ? typeOrder.length : i;
        };
        return list.slice().sort(function (x, y) {
          return rank(x.type) - rank(y.type) ||
            x.title.localeCompare(y.title, undefined, { numeric: true, sensitivity: 'base' });
        });
      }

      function brandHtml(brand, items) {
        var logo = logos[brand];
        var html = '<div class="res__brand"><h2 class="res__brand-head">' +
          (logo ? '<img src="' + esc(logo) + '" alt="" loading="lazy" width="80" height="32">' : '') +
          '<span>' + esc(brand) + '</span></h2>';

        var bySystem = {};
        items.forEach(function (d) { (bySystem[d.system] = bySystem[d.system] || []).push(d); });
        var names = Object.keys(bySystem).filter(Boolean);
        var isGeneral = function (n) {
          return generalGroups.some(function (g) { return g.toLowerCase() === n.toLowerCase(); });
        };
        var systems = names.filter(function (n) { return !isGeneral(n); }).sort(function (x, y) {
          return x.localeCompare(y, undefined, { numeric: true, sensitivity: 'base' });
        });
        var general = generalGroups.map(function (g) {
          return names.filter(function (n) { return n.toLowerCase() === g.toLowerCase(); })[0];
        }).filter(Boolean);
        var groups = systems.concat(general);
        if (bySystem['']) groups.push('');

        var overview = !state.q.trim() && !state.type && !state.component && !state.brand;
        var collapsible = overview && showFirst && systems.length > collapseOver;
        var limit = collapsible && !expanded[brand];

        var sysHtml = function (g, hide) {
          return '<div class="res__sys"' + (hide ? ' hidden' : '') + '>' +
            '<h3 class="res__sys-name">' + highlight(g || otherLabel) + '</h3>' +
            '<ul class="res__list" role="list">' + byType(bySystem[g]).map(itemHtml).join('') + '</ul></div>';
        };

        // A system is featured if any of its documents is marked Featured.
        var allFeatured = systems.filter(function (s) {
          return bySystem[s].some(function (d) { return d.featured; });
        });

        if (!collapsible) {
          // Overview: featured systems lead; search/filters keep plain A-Z.
          var order = overview
            ? allFeatured.concat(groups.filter(function (g) { return allFeatured.indexOf(g) === -1; }))
            : groups;
          order.forEach(function (g) { html += sysHtml(g, false); });
          return html + '</div>';
        }

        // Collapsed overview: featured systems first, capped at the maximum;
        // topped up A-Z to the minimum. Everything else sits behind
        // "Show all", under a "More <brand> systems" divider.
        var featured = allFeatured.slice(0, showFirst);
        var lead = featured.slice();
        systems.forEach(function (s) {
          if (lead.length < Math.min(showMin, showFirst) && lead.indexOf(s) === -1) lead.push(s);
        });
        var rest = groups.filter(function (g) { return lead.indexOf(g) === -1; });

        lead.forEach(function (g) { html += sysHtml(g, false); });
        if (rest.length) {
          html += '<p class="res__more-head"' + (limit ? ' hidden' : '') + '>More ' + esc(brand) + ' systems</p>';
          rest.forEach(function (g) { html += sysHtml(g, limit); });
          html += '<button type="button" class="res__more" data-more="' + esc(brand) + '" aria-expanded="' + (!limit) + '">' +
            (limit ? 'Show all ' + systems.length + ' ' + esc(brand) + ' systems' : 'Show less') + '</button>';
        }
        return html + '</div>';
      }

      function buildFilters() {
        function chips(name, values, allLabel, labelFn, force) {
          var el = bars[name];
          el.innerHTML = '';
          if (values.length < 2 && !state[name] && !force) {
            el.hidden = true;
            return;
          }
          el.hidden = false;
          var lab = document.createElement('span');
          lab.className = 'res__row-label';
          lab.textContent = el.getAttribute('aria-label');
          el.appendChild(lab);
          [''].concat(values).forEach(function (v) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'res__chip';
            b.dataset.value = v;
            b.textContent = v ? (labelFn ? labelFn(v) : v) : allLabel;
            el.appendChild(b);
          });
        }
        chips('type', ordered(docs.map(function (d) { return d.type; }).filter(Boolean), typeOrder), 'All', plural);
        // "Interactive" sits with the types: shows only interactive diagrams.
        if (docs.some(isInteractive)) {
          if (bars.type.hidden) chips('type', [], 'All', plural, true);
          var ib = document.createElement('button');
          ib.type = 'button';
          ib.className = 'res__chip res__chip--interactive';
          ib.dataset.value = 'interactive';
          ib.innerHTML = HAND + 'Interactive';
          bars.type.appendChild(ib);
        }
        chips('brand', ordered(docs.map(function (d) { return d.brand; }), []), 'All');
        if (app.dataset.componentFilter === 'true') {
          chips('component', ordered([].concat.apply([], docs.map(function (d) { return d.components; })), compOrder), 'All');
        } else {
          bars.component.hidden = true;
          state.component = '';
        }
      }

      function syncPressed() {
        Object.keys(bars).forEach(function (name) {
          bars[name].querySelectorAll('button').forEach(function (b) {
            b.setAttribute('aria-pressed', b.dataset.value === state[name] ? 'true' : 'false');
          });
        });
      }

      // Split brand cards into two columns at the point that best evens out
      // their heights, keeping alphabetical order down the left then the right.
      function balance(cards) {
        results.innerHTML = '';
        var two = window.matchMedia('(min-width: 750px)').matches && cards.length > 1;
        results.className = 'res__cols' + (two ? ' res__cols--two' : '');
        var left = document.createElement('div');
        results.appendChild(left);
        cards.forEach(function (c) { left.appendChild(c); });
        if (!two) return;
        var heights = cards.map(function (c) { return c.offsetHeight; });
        var total = heights.reduce(function (a, b) { return a + b; }, 0);
        var best = 1, bestDiff = Infinity, run = 0;
        for (var k = 1; k < cards.length; k++) {
          run += heights[k - 1];
          var diff = Math.abs(total - 2 * run);
          if (diff < bestDiff) { bestDiff = diff; best = k; }
        }
        var right = document.createElement('div');
        results.appendChild(right);
        cards.slice(best).forEach(function (c) { right.appendChild(c); });
      }

      function render() {
        syncPressed();
        var shown = docs.filter(function (d) { return matches(d); });
        var byBrand = {};
        shown.forEach(function (d) { (byBrand[d.brand] = byBrand[d.brand] || []).push(d); });
        var cards = ordered(Object.keys(byBrand), []).map(function (b) {
          var items = byBrand[b].sort(function (x, y) {
            return x.title.localeCompare(y.title, undefined, { numeric: true, sensitivity: 'base' });
          });
          var wrap = document.createElement('div');
          wrap.innerHTML = brandHtml(b, items);
          return wrap.firstChild;
        });
        balance(cards);

        count.textContent = shown.length + (shown.length === 1 ? ' document' : ' documents');
        empty.hidden = shown.length !== 0 || docs.length === 0;
        none.hidden = docs.length !== 0;
        root.querySelector('.res__bar').hidden = docs.length === 0;
        count.hidden = docs.length === 0;
        clear.hidden = !(state.q || state.type || state.component || state.brand);

        try {
          var p = new URLSearchParams(location.search);
          ['q', 'type', 'component', 'brand'].forEach(function (k) {
            var v = k === 'q' ? state.q.trim() : state[k];
            if (v) p.set(k, v);
            else p.delete(k);
          });
          var qs = p.toString();
          history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
        } catch (e) {}
      }

      Object.keys(bars).forEach(function (name) {
        bars[name].addEventListener('click', function (e) {
          var b = e.target.closest('button');
          if (!b) return;
          state[name] = name === 'brand' && state.brand === b.dataset.value ? '' : b.dataset.value;
          render();
        });
      });

      results.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-more]');
        if (!btn) return;
        var key = btn.dataset.more;
        expanded[key] = !expanded[key];
        var collapsing = !expanded[key];
        render();
        if (collapsing) {
          var again = results.querySelector('[data-more="' + key.replace(/"/g, '\\"') + '"]');
          if (again && again.getBoundingClientRect().top < 0) again.scrollIntoView({ block: 'center' });
        }
      });

      var t;
      qInput.value = state.q;
      qInput.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          state.q = qInput.value;
          render();
        }, 120);
      });

      clear.addEventListener('click', function () {
        state = { q: '', type: '', component: '', brand: '' };
        qInput.value = '';
        render();
      });

      var lastTwo = window.matchMedia('(min-width: 750px)').matches;
      window.addEventListener('resize', function () {
        var nowTwo = window.matchMedia('(min-width: 750px)').matches;
        if (nowTwo !== lastTwo) {
          lastTwo = nowTwo;
          render();
        }
      });

      readSource(source);
      source.hidden = true;
      app.hidden = false;
      buildFilters();
      render();

      // More than 250 documents: fetch the remaining pages of the plain list.
      function loadRest() {
        var next = source.querySelector('[data-next-page]');
        if (!next) return;
        var href = next.getAttribute('href');
        next.closest('li').remove();
        fetch(href)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var more = doc.querySelector('[data-resources] [data-source]');
            if (!more) return;
            readSource(more);
            var nextLink = more.querySelector('[data-next-page]');
            if (nextLink) source.appendChild(document.importNode(nextLink.closest('li'), true));
            buildFilters();
            render();
            loadRest();
          })
          .catch(function () {});
      }
      loadRest();
    }

    function boot() {
      document.querySelectorAll('[data-resources]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-estimator"] && !Shopify.designMode) return;
  try {
    
  class ShippingEstimator extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.resultsElement = this.querySelector('[data-shipping-estimator-results]');
      this.submitButton = this.form.querySelector('button[type="submit"]');
      this.submitButtonLabel = this.submitButton.textContent.trim();
      this.moneyFormat = this.getAttribute('data-money-format');

      this.countrySelect = this.form.querySelector('[name="address[country]"]');
      this.provinceSelect = this.form.querySelector('[name="address[province]"]');
      this.provinceContainer = this.querySelector('[id^="ShippingEstimatorProvinceContainer-"]');

      if (window.Shopify && window.Shopify.CountryProvinceSelector) {
        // eslint-disable-next-line no-new
        new window.Shopify.CountryProvinceSelector(this.countrySelect.id, this.provinceSelect.id, {
          hideElement: this.provinceContainer.id,
        });
      }

      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    async onSubmit(event) {
      event.preventDefault();

      const zip = this.form.querySelector('[name="address[zip]"]').value.trim();
      const country = this.countrySelect.value;
      const province = this.provinceContainer.style.display !== 'none' ? this.provinceSelect.value : '';

      if (!zip || !country) {
        this.renderError(window.shippingEstimatorStrings.missingFields);
        return;
      }

      this.setLoading(true);

      const params = new URLSearchParams();
      params.set('shipping_address[zip]', zip);
      params.set('shipping_address[country]', country);
      if (province) params.set('shipping_address[province]', province);

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/shipping_rates.json?${params.toString()}`);
        if (!response.ok) throw new Error('request-failed');
        const data = await response.json();
        this.renderRates(data.shipping_rates || []);
      } catch (error) {
        this.renderError(window.shippingEstimatorStrings.error);
      } finally {
        this.setLoading(false);
      }
    }

    renderRates(rates) {
      if (rates.length === 0) {
        this.renderError(window.shippingEstimatorStrings.noRates);
        return;
      }

      // Matches production: a single "rates start at" summary rather than a full
      // per-carrier breakdown - exact rates are still calculated at checkout.
      const lowestCents = rates.reduce((min, rate) => {
        const cents = this.dollarsToCents(rate.price);
        return cents < min ? cents : min;
      }, Infinity);

      const summary = window.shippingEstimatorStrings.ratesStartAt.replace(
        '[[price]]',
        this.formatMoney(lowestCents)
      );

      this.resultsElement.innerHTML = `
        <p class="shipping-estimator__rates-summary">${summary}</p>
        <p class="shipping-estimator__disclaimer">${window.shippingEstimatorStrings.exactAtCheckout}</p>
      `;
    }

    renderError(message) {
      this.resultsElement.innerHTML = `<p class="shipping-estimator__error">${message}</p>`;
    }

    dollarsToCents(dollars) {
      // /cart/shipping_rates.json returns rate.price as a decimal-dollar string
      // (e.g. "23.40"), unlike most other Ajax API responses which use integer
      // cents - formatMoney always expects cents, so convert here first.
      return Math.round(parseFloat(dollars) * 100);
    }

    formatMoney(cents) {
      // Formats using the shop's actual configured money format (Settings > General),
      // same as the production site's shipping calculator - not a generic Intl guess.
      const formatString = this.moneyFormat || '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = formatString.match(placeholderRegex);

      const withDelimiters = (number, precision, thousands, decimal) => {
        precision = precision === undefined ? 2 : precision;
        thousands = thousands === undefined ? ',' : thousands;
        decimal = decimal === undefined ? '.' : decimal;

        if (isNaN(number) || number == null) return '0';

        const fixed = (Number(number) / 100).toFixed(precision);
        const parts = fixed.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
        const centsPart = parts[1] ? decimal + parts[1] : '';

        return dollars + centsPart;
      };

      let value;
      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals':
          value = withDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = withDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = withDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = withDelimiters(cents, 2);
      }

      return match ? formatString.replace(placeholderRegex, value) : `$${value}`;
    }

    setLoading(isLoading) {
      this.submitButton.disabled = isLoading;
      this.submitButton.textContent = isLoading
        ? window.shippingEstimatorStrings.calculating
        : this.submitButtonLabel;
    }
  }

  customElements.define('shipping-estimator', ShippingEstimator);

  } catch(e) { console.error(e); }
})();
})();
